<div matSnackBarLabel class="py-4 flex flex-wrap items-start gap-2">
  <div class="flex justify-between items-start gap-2 w-full">
    @switch (operationInfo().status) {
      @case (OperationStatus.SUCCESS) {
        <mat-icon i18n matSnackBarAction class="text-green-700 shrink-0"
          >check_circle</mat-icon
        >
        <span
          >{{ operationInfo().message | transloco }}
          @if (!!operationInfo().url) {
            <a class="text-blue-500 break-all" [href]="operationInfo().url"
              >{{ 'COMMON.SETTINGS_FILES' | transloco }}
            </a>
          }
        </span>
      }

      @case (OperationStatus.ERROR) {
        <mat-icon i18n class="text-red-500 shrink-0">error</mat-icon>

        @if (isArray($any(operationInfo()).reason)) {
          <ul>
            @for (item of $any(operationInfo()).reason; track item) {
              <li>{{ item }}</li>
            }
          </ul>
        } @else {
          <span>{{ operationInfo().message | transloco }} </span>
          {{ $any(operationInfo()).reason }}
        }
      }
    }

    @if (operationInfo().closable) {
      <div class="shrink-0">
        <button (click)="closeModal()">
          <mat-icon i18n>close</mat-icon>
        </button>
      </div>
    }
  </div>
</div>
